/**
 * SoftwareApplicationJsonLd — tells Google "TurfPulse is an app/SaaS product."
 *
 * Unlocks rich result eligibility (price, rating stars, screenshots) and
 * categorizes the site under "lawn-care app" rather than a generic blog.
 *
 * Schema reference: https://schema.org/SoftwareApplication
 *
 * Note on aggregateRating: schema.org strongly recommends only including
 * this when you have real, verifiable user reviews. We omit it until you
 * have authentic ratings to back it up — fake ratings can earn a manual
 * action from Google's search team.
 */
import { Helmet } from 'react-helmet-async';

const APP = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'TurfPulse',
  applicationCategory: 'LifestyleApplication',
  applicationSubCategory: 'Lawn Care',
  operatingSystem: 'Web',
  url: 'https://getturfpulse.com',
  description:
    'TurfPulse is a smart lawn-care web app powered by Growing Degree Days, FAO-56 evapotranspiration, Smith-Kerns dollar-spot disease modeling, and live Ecowitt soil-moisture telemetry. Built for homeowners and lawn enthusiasts who want pro-grade timing without the agronomy degree.',
  featureList: [
    'Growing Degree Days (GDD) tracker per ZIP code',
    'FAO-56 ET₀ Water Budget calculator with cycle-and-soak',
    'Smith-Kerns dollar spot disease pressure model',
    'Ecowitt soil moisture + Wunderground PWS integration',
    'Rachio sprinkler controller closed-loop scheduling',
    'Soil test PDF parser (Waypoint, Logan Labs, UMass)',
    'FRAC/HRAC/IRAC resistance rotation tracker',
  ],
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    availability: 'https://schema.org/InStock',
    description: 'Free tier with paid plans for advanced features',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Hi Tex Lawn Pro LLC',
    url: 'https://getturfpulse.com',
  },
  screenshot: 'https://getturfpulse.com/og-image.png',
};

export const SoftwareApplicationJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(APP)}</script>
  </Helmet>
);

export default SoftwareApplicationJsonLd;
